export enum TapToPayPluginErrors {
  CollectPaymentMethodError = 'COLLECT_PAYMENT_METHOD_ERROR',
  CompletePaymentError = 'COMPLETE_PAYMENT_ERROR',
  ConfigureConnectionTokenError = 'CONFIGURE_CONNECTION_TOKEN_ERROR',
  ConnectLocalMobileReaderError = 'CONNECT_LOCAL_MOBILE_READER_ERROR',
  DetectTapToPayDevicesError = 'DETECT_TAP_TO_PAY_DEVICES_ERROR',
  DisconnectReaderError = 'DISCONNECT_READER_ERROR',
  DiscoverReadersError = 'DISCOVER_READERS_ERROR',
  LoadPluginError = 'LOAD_PLUGIN_ERROR',
  OpenSettingsAppError = 'OPEN_SETTINGS_APP_ERROR',
  ProcessPaymentError = 'PROCESS_PAYMENT_ERROR',
  RetrievePaymentIntentError = 'RETRIEVE_PAYMENT_INTENT_ERROR',
  UnexpectedReaderDisconnectError = 'UNEXPECTED_READER_DISCONNECT_ERROR',
}

export enum TapToPayPluginEvent {
  DidStartDiscoverReaders = 'didStartDiscoverReaders',
  DidReportUnexpectedReaderDisconnect = 'didReportUnexpectedReaderDisconnect',
  DidStartInstallingUpdate = 'didStartInstallingUpdate',
  DidReportReaderSoftwareUpdateProgress = 'didReportReaderSoftwareUpdateProgress',
  DidFinishInstallingUpdate = 'didFinishInstallingUpdate',
  DidConnectReader = 'didConnectReader',
  DidCancelDiscoverReaders = 'didCancelDiscoverReaders',
  DidRequestReaderInput = 'didRequestReaderInput',
  DidRequestReaderDisplayMessage = 'didRequestReaderDisplayMessage',
  DidCollectPaymentMethod = 'didCollectPaymentMethod',
  DidProcessPaymentIntent = 'didProcessPaymentIntent',
  DidChangeLocationAuthorization = 'didChangeLocationAuthorization',
  DidDisconnectReader = 'didDisconnectReader',
  DidRequestConnectionStatus = 'didRequestConnectionStatus',
}

// Mirrors SCPConnectionStatus: https://stripe.dev/stripe-terminal-ios/docs/Enums/SCPConnectionStatus.html#/c:@E@SCPConnectionStatus@SCPConnectionStatusConnecting
export enum TapToPayConnectionStatus {
  NotConnected = 0,
  Connected = 1,
  Connecting = 2,
}

export enum TapToPayGeolocationAuthorizationStatus {
  Unknown = 'unknown',
  NotDetermined = 'notDetermined',
  Authorized = 'authorized',
  Denied = 'denied',
  Restricted = 'restricted',
}
